<template>
  <div>
    <vimeo-player :id="id" :ementaId="ementaId" :urlVideo="urlVideo" :tipoOrigemId="tipoOrigemId" :inicio="inicio"  ref="vimeoVideoPlayer" v-if="urlVideo && tipoOrigemId === 1"></vimeo-player>
    <youtube-player :id="id" :ementaId="ementaId" :urlVideo="urlVideo" :tipoOrigemId="tipoOrigemId" :inicio="inicio" ref="youtubeVideoPlayer" v-if="urlVideo && tipoOrigemId === 2"></youtube-player>
    <sambatech-player :ementaId="ementaId" :urlVideo="urlVideo" :tipoOrigemId="tipoOrigemId" :inicio="inicio" ref="sambatechVideoPlayer" v-if="urlVideo && tipoOrigemId === 3 && montarSambaPlayer"></sambatech-player>
  </div>
</template>

<script>
import VimeoPlayer from './VimeoPlayer'
import YoutubePlayer from './YoutubePlayer'
import SambatechPlayer from './SambatechPlayer'

export default {
  name: 'EmbeddedVideo',
  components: {
    VimeoPlayer,
    YoutubePlayer,
    SambatechPlayer
  },
  props: {
    id: Number,
    ementaId: Number,
    tipoOrigemId: Number,
    url: {
      type: String,
      required: true
    },
    inicio: Number
  },

  data () {
    return {
      montarSambaPlayer: null
    }
  },

  computed: {
    urlVideo: function () {
      if (this.url && !this.url.startsWith('https')) {
        return `https:${this.url}`
      }
      return this.url
    }
  },

  methods: {
    play () {
      if (this.tipoOrigemId === 1) {
        this.$refs.vimeoVideoPlayer.play()
      } else if (this.tipoOrigemId === 2) {
        this.$refs.youtubeVideoPlayer.play()
      } else if (this.tipoOrigemId === 3) {
        this.montarSambaPlayer = true
      }
    }
  }
}
</script>

<style scoped>

</style>
